import React, { useContext, useEffect, Suspense } from 'react';
import { useNavigate } from 'react-router-dom';
import { GlobalContext } from '../lib/GlobalVar';
import PerguntarPublico from './PerguntarPublico/PerguntarPublico';
import { definirSenhaExterna, limparSenhaExterna } from '../personalizados/PerguntarDados/api';
import { BabitaLogo } from './BabitaLogo';
import VoltarAoTopo from './VoltarAoTopo';

// /perguntar — ENTRADA UNICA de "Pergunte para o Babito".
// Sem sessao: renderiza a landing publica unificada (PerguntarPublico) com 3 modos —
// Explorar (publico), Sou revendedora (CPF/CNPJ+senha) e Sou da equipe (Login funcionario).
// Com sessao (revendedora OU funcionario): renderiza o MESMO motor de chat (PerguntarDados)
// em tela cheia; o backend deriva escopo/abas do `solicitante` (email do user, ou CPF).
const PerguntarDados = React.lazy(() => import('../personalizados/PerguntarDados/PerguntarDados'));

export default function ChatDireto() {
    const { user, logout } = useContext(GlobalContext);
    const navigate = useNavigate();
    // '/' e a rota do LOGIN (App.jsx declara <Route path="/" element={<Login/>}/> ANTES do
    // shell), entao navigate('/') jogava o usuario logado na tela de login. O destino certo
    // e o Dashboard — mesmo alvo do atalho Ctrl+D da Topbar.
    const irHome = () => navigate('/Dashboard');

    // Revendedora: NAO ha sessao no backend — cada chamada precisa reenviar a senha. O `user`
    // persiste no localStorage, mas a senha em memoria (api.js) some a cada F5: reidrata aqui.
    useEffect(() => {
        if (user && user.ehRevendedora && user.senha) definirSenhaExterna(user.senha);
    }, [user]);

    // Atalho na tela inicial do celular: o <link rel="manifest"> do index.html aponta para
    // /manifest.json, cujo start_url e a raiz — por isso um atalho adicionado de QUALQUER
    // pagina abria em "/", nunca na pagina em que a pessoa estava (o navegador le o manifest
    // e ignora a URL atual). Enquanto o Cockpit esta montado, aponta para
    // /manifest-cockpit.json (start_url /cockpit, id proprio) e devolve o anterior ao sair.
    // Fica ANTES do early return de `!user` porque hook nao pode rodar condicionalmente.
    useEffect(() => {
        const link = document.querySelector('link[rel="manifest"]');
        if (!link) return undefined;
        const anterior = link.getAttribute('href');
        link.setAttribute('href', '/manifest-cockpit.json');
        return () => link.setAttribute('href', anterior);
    }, []);

    // Sem login: landing publica na MESMA URL (nao redireciona pro Login).
    if (!user) return <PerguntarPublico />;

    function sair() {
        if (user.ehRevendedora) limparSenhaExterna();
        logout();
        navigate('/cockpit', { replace: true });
    }

    return (
        <div className="chat-direto">
            <header className="cd-head">
                <div className="cd-brand">
                    {user.ehRevendedora
                        ? <span className="cd-logo"><BabitaLogo color="var(--ink)" /></span>
                        : <button type="button" className="cd-logo cd-home" onClick={irHome} title="Voltar aos dashboards" aria-label="Voltar aos dashboards"><BabitaLogo color="var(--ink)" /></button>}
                    <span className="cd-title">Cockpit</span>
                </div>
                <div className="cd-user">
                    {!user.ehRevendedora && <button className="btn ghost sm" onClick={irHome} title="Voltar aos dashboards">← Dashboards</button>}
                    <span className="cd-quem" title={user.email || ''}>
                        {user.nome || user.email}{user.setor ? ` · ${user.setor}` : ''}
                    </span>
                    <button className="btn ghost sm" onClick={sair}>Sair</button>
                </div>
            </header>
            <main className="cd-body">
                <Suspense fallback={<div className="page muted" style={{ padding: 24 }}>Carregando…</div>}>
                    <PerguntarDados />
                </Suspense>
            </main>
            <VoltarAoTopo/>
        </div>
    );
}
